const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/backofficebff/service/api/v1";
export const ProductTransferCommand: any = {
    ProcessModelWithComponentsByModelId: Backofficebff + '/v1/producttransfer/processmodelwithcomponentsbymodelid',
};
